import Preview01 from '../../assets/blog/blog01.png';
import Preview02 from '../../assets/blog/blog02.png';
import Preview03 from '../../assets/blog/blog03.png';
import Preview04 from '../../assets/blog/blog04.png';
import Preview05 from '../../assets/blog/blog05.png';
import Preview06 from '../../assets/blog/blog06.png';

export const storiesData = [
  {
    image: Preview01,
    id: '1',
    title: 'SUPER BLOG ARTICLE!',
    description:
      'Lorem ipsum dolor sit amet, consectetur undo thes tabore et dolore magna aliqua.',
    date: '21 April 2020',
  },
  {
    image: Preview02,
    id: '2',
    title: 'AWESOME ARTICLE!',
    description: 'Lorem ipsum dolor undo thes tabore et dolore magna aliqua.',
    date: '27 April 2020',
  },
  {
    image: Preview03,
    id: '3',
    title: 'SUPER TITLE!',
    description: 'Lorem tabore et dolore magna aliqua ipsum dolor undo thes.',
    date: '03 May 2020',
  },
  {
    image: Preview04,
    id: '4',
    title: 'BLOG TITLE!',
    description: 'Lorem tabore et dolore magna aliqua ipsum dolor undo thes.',
    date: '15 May 2020',
  },
  {
    image: Preview05,
    id: '5',
    title: 'BLOG ARTICLE!',
    description: 'Lorem tabore et dolore magna aliqua ipsum dolor undo thes.',
    date: '20 May 2020',
  },
  {
    image: Preview06,
    id: '6',
    title: 'AWESOME TITLE!',
    description: 'Lorem tabore et dolore magna aliqua ipsum dolor undo thes.',
    date: '23 May 2020',
  },
];
